export default "<tc-generic-list #clientsList id=\"clients-list\"></tc-generic-list>";